<form [formGroup]="formCadastrar" (submit)="OnSalvar()" aria-labelledby="form-title">
  <breadcrumb *ngIf="!ehModal && !showCadastroModal" [paginas]="[
      { route:'/home', name:'Home' },
      { route:'/plano-contingencia/cadastro', name:'Plano de Contingência' }
    ]" aria-label="Navegação de breadcrumb" />

  <!-- FILTRO ESCOLA -->
  <section *ngIf="!ehModal && !showCadastroModal" class="section-filtro" aria-labelledby="filtro-escola-title">
    <div class="container">
      <div class="grupo-filter">
        <p><b>URE</b></p>
        <ng-select [items]="diretorias" bindLabel="nomeDiretoria" bindValue="codigoDiretoria"
          formControlName="codigoDiretoria" [disabled]="true"></ng-select>
      </div>

      <div class="grupo-filter">
        <p><b>Escola</b></p>
        <ng-select [items]="escolas" bindLabel="nomeEscola" bindValue="codigoEscola" placeholder="Selecione uma Escola"
          formControlName="codigoEscola" name="codigoEscola"
          [ngClass]="{ 'is-invalid': submitted && form.codigoEscola.errors }"
          aria-describedby="escola-error"></ng-select>
        <div *ngIf="submitted && form.codigoEscola.errors" class="alert">
          <div *ngIf="form.codigoEscola.errors.required">* Escola é obrigatório</div>
        </div>
      </div>
    </div>
  </section>

  <!-- TÍTULO -->
  <section *ngIf="!ehModal && !showCadastroModal" class="section-saudacao">
    <div class="container header-page">
      <h2 class="titulo-page">Planos de Contingência</h2>

      <button type="button" class="btn_primary" id="btn-cadastrar-plano" aria-label="Cadastrar plano"
        (click)="OnOpenModal()">
        <i class="fa-plus fa-solid icon-white"></i>
        <span>Cadastrar plano</span>
      </button>

    </div>
  </section>

  <!-- TITULO MODAL + Histórico de atualizações -->
  <section *ngIf="ehModal" class="conteudo-principal section-modal-titulo-historic" aria-labelledby="detalhes-chamado-title">
    <div class="container-titulo-historic">
      <h2 class="font-modal-acao">{{ tituloAcaoModal }}</h2>
      <a class="link-historic-atualizacoes"
         (click)="abrirModalHistorico()"
         (keydown.enter)="abrirModalHistorico()"
         (keydown.space)="abrirModalHistorico()"
         role="button" tabindex="0">
        <i class="fa fa-arrows-rotate" aria-hidden="true"></i> Histórico de atualizações
      </a>
    </div>
    <br />
    <section>
      <h3 class="info-plano text-dark margin-bottom-20">Informação do Plano</h3>
      <h4 *ngIf="statusPlano !== null && statusPlano !== undefined" class="info-plano-status text-muted">Status</h4>
      <div *ngIf="statusPlano !== null && statusPlano !== undefined" class="status-container">
        <span class="status-circle span-status-circle" [ngClass]="{
          'status-pendente': statusPlano === 0,
          'status-aprovado': statusPlano === 1,
          'status-reprovado': statusPlano === 2,
          'status-novo': statusPlano === 3,
          'status-validacao-supervisor-Ensino': statusPlano === 4,
          'status-validacao-pec-conviva': statusPlano === 5,
          'status-devolvido-ajustes': statusPlano === 6,
          'sem-status': statusPlano === null || statusPlano === undefined
        }"></span>
        <span class="status-text">{{
          statusPlano === 0 ? 'Pendente' :
          statusPlano === 1 ? 'Aprovado' :
          (statusPlano === 2 || statusPlano === 6) ? 'Devolvido para ajustes' :
          statusPlano === 3 ? 'Novo' :
          statusPlano === 4 ? 'Aguardando validação Supervisor de Ensino' :
          statusPlano === 5 ? 'Aguardando validação PEC CONVIVA' : 'Pendente'
          }}</span>
      </div>

      <!-- Justificativa da reprovação (Devolvido para ajustes) – Cenário 8 -->
      <div *ngIf="(statusPlano === 2 || statusPlano === 6) && ehModal" class="conteudo-textarea" style="width: 100%; margin-top: 15px;">
        <label class="info-plano text-dark">Justificativa (Devolvido para ajustes)</label>
        <textarea rows="4" [value]="justificativaReprovacao || 'Não informada'" readonly
          class="form-control" style="resize: none; background: #f5f5f5;"></textarea>
      </div>
    </section>
    <br /><br />
  </section>

  <!-- DADOS DO PLANO -->
  <section *ngIf="ehModal" class="conteudo-principal" aria-labelledby="detalhes-plano-title">
    <div class="container">
      <div class="time-line conteudo-registro">

        <div class="conteudo-select" style="max-width: 200px;">
          <label for="vigencia">Vigência</label>
          <ng-select id="vigencia" name="vigencia" [items]="anosVigencia" placeholder="Selecione o ano"
            formControlName="vigencia" aria-label="Selecione o ano"></ng-select>
          <div *ngIf="submitted && form.vigencia.errors" class="alert">
            <div *ngIf="form.vigencia.errors.required">* Vigência é obrigatória</div>
            <div *ngIf="form.vigencia.errors.vigenciaInvalida">* Vigência inválida. Selecione o ano atual ou o seguinte.</div>
          </div>
        </div>

        <div class="conteudo-textarea">
          <label for="comite">Comitê</label>
          <textarea id="comite" name="comite" rows="5" minlength="10" maxlength="500" formControlName="comite"
            aria-label="Descreva o comitê responsável"></textarea>
          <small class="campo-ajuda">Mínimo: 10 caracteres • {{qtdeCaracteresComite}}/500</small>
          <div *ngIf="submitted && form.comite.errors" class="alert">
            <div *ngIf="form.comite.errors.required">* Comitê é obrigatório</div>
            <div *ngIf="form.comite.errors.minlength">* Digite no mínimo 10 caracteres</div>
            <div *ngIf="form.comite.errors.maxlength">* Digite no máximo 500 caracteres</div>
          </div>
        </div>

        <div class="conteudo-select">
          <label for="nomeResponsavel">Nome do Responsável (Diretor)</label>
          <input id="nomeResponsavel" type="text" name="nomeResponsavel" maxlength="150"
            formControlName="nomeResponsavel" aria-label="Digite o responsável" />
          <small class="campo-ajuda">{{form.nomeResponsavel.value?.length || 0}}/150</small>
          <div *ngIf="submitted && form.nomeResponsavel.errors" class="alert">
            <div *ngIf="form.nomeResponsavel.errors.required">* Responsável é obrigatória</div>
            <div *ngIf="form.nomeResponsavel.errors.maxlength">* Máximo de 150 caracteres</div>
          </div>
        </div>

        <!-- TABELA DE RISCOS -->
        <div class="conteudo-tabela">
          <table>
            <thead>
              <tr>
                <th>Riscos adicionados</th>
              </tr>
            </thead>
            <tbody formArrayName="riscos">
              <tr *ngFor="let riscoCtrl of riscosForm.controls; let i = index" [formGroupName]="i">
                <td>
                  <div class="risco-bloco">
                    <h4 class="risco-titulo">Risco {{i + 1}}</h4>

                    <!-- SEÇÃO: RISCO -->
                    <div class="secao-risco">
                      <h5 class="secao-titulo">Risco</h5>
                      <p class="secao-descricao">É a possibilidade de ocorrer um evento adverso que pode causar danos à
                        escola. A combinação entre: o que pode acontecer + quão exposta a escola está + o impacto
                        esperado.</p>

                      <div class="campo">
                        <label for="perigo-{{i}}">Perigo *</label>
                        <ng-select id="perigo-{{i}}" [items]="opcoesPerigo" formControlName="perigo" [multiple]="true"
                          placeholder="Insira o perigo" [disabled]="ehReadOnly"></ng-select>
                        <small class="campo-ajuda">Fonte ou situação com potencial de causar um evento danoso. Não é
                          fragilidade nem consequência. É a ameaça em si.</small>
                        <div *ngIf="submitted && riscoCtrl.get('perigo')?.errors" class="alert">
                          <div *ngIf="riscoCtrl.get('perigo')?.errors?.['required']">* Campo é obrigatório</div>
                        </div>
                      </div>

                      <div class="campo">
                        <label for="vulnerabilidade-{{i}}">Vulnerabilidade *</label>
                        <ng-select id="vulnerabilidade-{{i}}" [items]="opcoesVulnerabilidade"
                          formControlName="vulnerabilidade" [multiple]="true" placeholder="Selecione a vulnerabilidade"
                          [disabled]="ehReadOnly"></ng-select>
                        <div *ngIf="submitted && riscoCtrl.get('vulnerabilidade')?.errors" class="alert">
                          <div *ngIf="riscoCtrl.get('vulnerabilidade')?.errors?.['required']">* Campo é obrigatório
                          </div>
                        </div>
                      </div>

                      <div class="campo">
                        <label for="justificativaVulnerabilidade-{{i}}">Justificativa de vulnerabilidade *</label>
                        <textarea id="justificativaVulnerabilidade-{{i}}" formControlName="justificativaVulnerabilidade"
                          rows="3" placeholder="Insira a justificativa de vulnerabilidade" minlength="10" maxlength="500"></textarea>
                        <small class="campo-ajuda">Mínimo: 10 caracteres •
                          {{riscoCtrl.get('justificativaVulnerabilidade')?.value?.length || 0}}/500</small>
                        <small class="campo-ajuda">Condições que aumentam a chance de o perigo causar danos,
                          relacionadas à estrutura, organização, localização ou preparo da escola. Informar o
                          responsável pela ação.</small>
                        <div *ngIf="submitted && riscoCtrl.get('justificativaVulnerabilidade')?.errors" class="alert">
                          <div *ngIf="riscoCtrl.get('justificativaVulnerabilidade')?.errors?.['required']">* Campo é
                            obrigatório</div>
                          <div *ngIf="riscoCtrl.get('justificativaVulnerabilidade')?.errors?.['minlength']">* Mínimo de
                            10 caracteres</div>
                          <div *ngIf="riscoCtrl.get('justificativaVulnerabilidade')?.errors?.['maxlength']">* Máximo de
                            500 caracteres</div>
                        </div>
                      </div>

                      <div class="campo">
                        <label for="dano-{{i}}">Dano *</label>
                        <ng-select id="dano-{{i}}" [items]="opcoesDano" formControlName="dano" [multiple]="true"
                          placeholder="Selecione o dano" [disabled]="ehReadOnly"></ng-select>
                        <small class="campo-ajuda">Consequências caso o risco ou perigo se concretizem. Não é ameaça nem
                          fragilidade. É o resultado do evento</small>
                        <div *ngIf="submitted && riscoCtrl.get('dano')?.errors" class="alert">
                          <div *ngIf="riscoCtrl.get('dano')?.errors?.['required']">* Campo é obrigatório</div>
                        </div>
                      </div>

                      <div class="campo">
                        <label for="justificativaDano-{{i}}">Justificativa de dano *</label>
                        <textarea id="justificativaDano-{{i}}" formControlName="justificativaDano" rows="3"
                          placeholder="Insira a justificativa de dano" minlength="10" maxlength="500"></textarea>
                        <small class="campo-ajuda">Mínimo: 10 caracteres •
                          {{riscoCtrl.get('justificativaDano')?.value?.length || 0}}/500</small>
                        <small class="campo-ajuda">Consequências negativas que podem ocorrer caso o risco se concretize.
                          Informar o responsável pela ação.</small>
                        <div *ngIf="submitted && riscoCtrl.get('justificativaDano')?.errors" class="alert">
                          <div *ngIf="riscoCtrl.get('justificativaDano')?.errors?.['required']">* Campo é obrigatório
                          </div>
                          <div *ngIf="riscoCtrl.get('justificativaDano')?.errors?.['minlength']">* Mínimo de 10
                            caracteres</div>
                          <div *ngIf="riscoCtrl.get('justificativaDano')?.errors?.['maxlength']">* Máximo de 500
                            caracteres</div>
                        </div>
                      </div>

                      <div class="campo">
                        <label for="grauRisco-{{i}}">Grau de risco *</label>
                        <ng-select id="grauRisco-{{i}}" [items]="opcoesGrauRisco" formControlName="grauRisco"
                          placeholder="Selecione o grau de risco" [disabled]="ehReadOnly"></ng-select>
                        <small class="campo-ajuda">Avaliação do nível de risco, considerando a probabilidade de o evento
                          ocorrer e a gravidade dos danos esperados.</small>
                        <div *ngIf="submitted && riscoCtrl.get('grauRisco')?.errors" class="alert">
                          <div *ngIf="riscoCtrl.get('grauRisco')?.errors?.['required']">* Campo é obrigatório</div>
                        </div>
                      </div>

                      <div class="campo">
                        <label for="justificativaGrauRisco-{{i}}">Justificativa de grau de risco *</label>
                        <textarea id="justificativaGrauRisco-{{i}}" formControlName="justificativaGrauRisco" rows="3"
                          placeholder="Insira a justificativa de grau de risco" minlength="10" maxlength="500"></textarea>
                        <small class="campo-ajuda">Mínimo: 10 caracteres •
                          {{riscoCtrl.get('justificativaGrauRisco')?.value?.length || 0}}/500</small>
                        <small class="campo-ajuda">Avaliação do nível de risco, considerando a probabilidade de o evento
                          ocorrer e a gravidade dos danos esperados. Informar o responsável pela ação.</small>
                        <div *ngIf="submitted && riscoCtrl.get('justificativaGrauRisco')?.errors" class="alert">
                          <div *ngIf="riscoCtrl.get('justificativaGrauRisco')?.errors?.['required']">* Campo é
                            obrigatório</div>
                          <div *ngIf="riscoCtrl.get('justificativaGrauRisco')?.errors?.['minlength']">* Mínimo de 10
                            caracteres</div>
                          <div *ngIf="riscoCtrl.get('justificativaGrauRisco')?.errors?.['maxlength']">* Máximo de 500
                            caracteres</div>
                        </div>
                      </div>
                    </div>

                    <div class="separador"></div>

                    <!-- SEÇÃO: AÇÕES ANTES DO FATO -->
                    <div class="secao-risco">
                      <h5 class="secao-titulo">Ações antes do fato</h5>
                      <p class="secao-descricao">Conjunto de ações planejadas antes da ocorrência do evento, com o
                        objetivo de evitar, reduzir ou se preparar para situações de emergência.</p>

                      <div class="campo">
                        <label for="prevencao-{{i}}">Prevenção *</label>
                        <textarea id="prevencao-{{i}}" formControlName="prevencao" rows="3"
                          placeholder="Insira a prevenção" minlength="10" maxlength="500"></textarea>
                        <small class="campo-ajuda">Mínimo: 10 caracteres •
                          {{riscoCtrl.get('prevencao')?.value?.length || 0}}/500</small>
                        <small class="campo-ajuda">Ações que reduzem os impactos caso o evento aconteça. Informar o
                          responsável pela ação.</small>
                        <div *ngIf="submitted && riscoCtrl.get('prevencao')?.errors" class="alert">
                          <div *ngIf="riscoCtrl.get('prevencao')?.errors?.['required']">* Campo é obrigatório</div>
                          <div *ngIf="riscoCtrl.get('prevencao')?.errors?.['minlength']">* Mínimo de 10 caracteres
                          </div>
                          <div *ngIf="riscoCtrl.get('prevencao')?.errors?.['maxlength']">* Máximo de 500 caracteres
                          </div>
                        </div>
                      </div>

                      <div class="campo">
                        <label for="mitigacao-{{i}}">Mitigação *</label>
                        <textarea id="mitigacao-{{i}}" formControlName="mitigacao" rows="3"
                          placeholder="Insira a mitigação" minlength="10" maxlength="500"></textarea>
                        <small class="campo-ajuda">Mínimo: 10 caracteres •
                          {{riscoCtrl.get('mitigacao')?.value?.length || 0}}/500</small>
                        <small class="campo-ajuda">Ações que reduzem os impactos caso o evento aconteça. Informar o
                          responsável pela ação.</small>
                        <div *ngIf="submitted && riscoCtrl.get('mitigacao')?.errors" class="alert">
                          <div *ngIf="riscoCtrl.get('mitigacao')?.errors?.['required']">* Campo é obrigatório</div>
                          <div *ngIf="riscoCtrl.get('mitigacao')?.errors?.['minlength']">* Mínimo de 10 caracteres
                          </div>
                          <div *ngIf="riscoCtrl.get('mitigacao')?.errors?.['maxlength']">* Máximo de 500 caracteres
                          </div>
                        </div>
                      </div>

                      <div class="campo">
                        <label for="preparacao-{{i}}">Preparação *</label>
                        <textarea id="preparacao-{{i}}" formControlName="preparacao" rows="3"
                          placeholder="Insira a preparação" minlength="10" maxlength="500"></textarea>
                        <small class="campo-ajuda">Mínimo: 10 caracteres •
                          {{riscoCtrl.get('preparacao')?.value?.length || 0}}/500</small>
                        <small class="campo-ajuda">Ações que organizam a escola para responder adequadamente a uma
                          emergência. Informar o responsável pela ação.</small>
                        <div *ngIf="submitted && riscoCtrl.get('preparacao')?.errors" class="alert">
                          <div *ngIf="riscoCtrl.get('preparacao')?.errors?.['required']">* Campo é obrigatório</div>
                          <div *ngIf="riscoCtrl.get('preparacao')?.errors?.['minlength']">* Mínimo de 10 caracteres
                          </div>
                          <div *ngIf="riscoCtrl.get('preparacao')?.errors?.['maxlength']">* Máximo de 500 caracteres
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="separador"></div>

                    <!-- SEÇÃO: AÇÕES DURANTE O FATO -->
                    <div class="secao-risco">
                      <h5 class="secao-titulo">Ações durante o fato</h5>
                      <p class="secao-descricao">Conjunto de ações executadas no momento da ocorrência de emergência,
                        com foco em proteger vidas, reduzir danos e manter a ordem.</p>

                      <div class="campo">
                        <label for="evacuacaoPredio-{{i}}">Evacuação do Prédio *</label>
                        <textarea id="evacuacaoPredio-{{i}}" formControlName="evacuacaoPredio" rows="3"
                          placeholder="Insira a evacuação do prédio" minlength="10" maxlength="500"></textarea>
                        <small class="campo-ajuda">Mínimo: 10 caracteres •
                          {{riscoCtrl.get('evacuacaoPredio')?.value?.length || 0}}/500</small>
                        <small class="campo-ajuda">Organização para a saída segura. Informar o responsável pela
                          ação.</small>
                        <div *ngIf="submitted && riscoCtrl.get('evacuacaoPredio')?.errors" class="alert">
                          <div *ngIf="riscoCtrl.get('evacuacaoPredio')?.errors?.['required']">* Campo é obrigatório
                          </div>
                          <div *ngIf="riscoCtrl.get('evacuacaoPredio')?.errors?.['minlength']">* Mínimo de 10
                            caracteres</div>
                          <div *ngIf="riscoCtrl.get('evacuacaoPredio')?.errors?.['maxlength']">* Máximo de 500
                            caracteres</div>
                        </div>
                      </div>

                      <div class="campo">
                        <label for="acionamentoOrgaos-{{i}}">Acionamento dos órgãos de segurança/saúde *</label>
                        <textarea id="acionamentoOrgaos-{{i}}" formControlName="acionamentoOrgaos" rows="3"
                          placeholder="Insira os acionamento dos órgãos de segurança/saúde" minlength="10" maxlength="500"></textarea>
                        <small class="campo-ajuda">Mínimo: 10 caracteres •
                          {{riscoCtrl.get('acionamentoOrgaos')?.value?.length || 0}}/500</small>
                        <small class="campo-ajuda">Defesa Civil, Corpo de Bombeiros, Polícia Militar etc. Informar o
                          responsável pela ação.</small>
                        <div *ngIf="submitted && riscoCtrl.get('acionamentoOrgaos')?.errors" class="alert">
                          <div *ngIf="riscoCtrl.get('acionamentoOrgaos')?.errors?.['required']">* Campo é obrigatório
                          </div>
                          <div *ngIf="riscoCtrl.get('acionamentoOrgaos')?.errors?.['minlength']">* Mínimo de 10
                            caracteres</div>
                          <div *ngIf="riscoCtrl.get('acionamentoOrgaos')?.errors?.['maxlength']">* Máximo de 500
                            caracteres</div>
                        </div>
                      </div>

                      <div class="campo">
                        <label for="isolamentoAreas-{{i}}">Isolamento das áreas de risco *</label>
                        <textarea id="isolamentoAreas-{{i}}" formControlName="isolamentoAreas" rows="3"
                          placeholder="Insira o isolamento das áreas de risco" minlength="10" maxlength="500"></textarea>
                        <small class="campo-ajuda">Mínimo: 10 caracteres •
                          {{riscoCtrl.get('isolamentoAreas')?.value?.length || 0}}/500</small>
                        <small class="campo-ajuda">Informar o responsável pela ação.</small>
                        <div *ngIf="submitted && riscoCtrl.get('isolamentoAreas')?.errors" class="alert">
                          <div *ngIf="riscoCtrl.get('isolamentoAreas')?.errors?.['required']">* Campo é obrigatório
                          </div>
                          <div *ngIf="riscoCtrl.get('isolamentoAreas')?.errors?.['minlength']">* Mínimo de 10
                            caracteres</div>
                          <div *ngIf="riscoCtrl.get('isolamentoAreas')?.errors?.['maxlength']">* Máximo de 500
                            caracteres</div>
                        </div>
                      </div>

                      <div class="campo">
                        <label for="comunicacaoURE-{{i}}">Comunicação com a equipe da Unidade Regional de Ensino (URE)
                          *</label>
                        <textarea id="comunicacaoURE-{{i}}" formControlName="comunicacaoURE" rows="3"
                          placeholder="Insira a comunicação com a equipe da Unidade Regional de Ensino"
                          minlength="10" maxlength="500"></textarea>
                        <small class="campo-ajuda">Mínimo: 10 caracteres •
                          {{riscoCtrl.get('comunicacaoURE')?.value?.length || 0}}/500</small>
                        <small class="campo-ajuda">Informar o responsável pela ação.</small>
                        <div *ngIf="submitted && riscoCtrl.get('comunicacaoURE')?.errors" class="alert">
                          <div *ngIf="riscoCtrl.get('comunicacaoURE')?.errors?.['required']">* Campo é obrigatório</div>
                          <div *ngIf="riscoCtrl.get('comunicacaoURE')?.errors?.['minlength']">* Mínimo de 10 caracteres
                          </div>
                          <div *ngIf="riscoCtrl.get('comunicacaoURE')?.errors?.['maxlength']">* Máximo de 500 caracteres
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="separador"></div>

                    <!-- SEÇÃO: AVALIAÇÃO DO FATO OCORRIDO -->
                    <div class="secao-risco">
                      <h5 class="secao-titulo">Avaliação do Fato Ocorrido</h5>
                      <p class="secao-descricao">Conjunto de ações realizadas após o evento, com o objetivo de
                        restabelecer a segurança e o funcionamento da escola</p>

                      <div class="campo">
                        <label for="avaliacaoDanos-{{i}}">Avaliação do Fato Ocorrido *</label>
                        <textarea id="avaliacaoDanos-{{i}}" formControlName="avaliacaoDanos" rows="3"
                          placeholder="Insira a avaliação do fato ocorrido" minlength="10" maxlength="500"></textarea>
                        <small class="campo-ajuda">Mínimo: 10 caracteres •
                          {{riscoCtrl.get('avaliacaoDanos')?.value?.length || 0}}/500</small>
                        <small class="campo-ajuda">Avaliação dos danos. Informar o responsável pela ação.</small>
                        <div *ngIf="submitted && riscoCtrl.get('avaliacaoDanos')?.errors" class="alert">
                          <div *ngIf="riscoCtrl.get('avaliacaoDanos')?.errors?.['required']">* Campo é obrigatório</div>
                          <div *ngIf="riscoCtrl.get('avaliacaoDanos')?.errors?.['minlength']">* Mínimo de 10 caracteres
                          </div>
                          <div *ngIf="riscoCtrl.get('avaliacaoDanos')?.errors?.['maxlength']">* Máximo de 500 caracteres
                          </div>
                        </div>
                      </div>

                      <div class="campo">
                        <label for="limpezaReorganizacao-{{i}}">Limpeza e reorganização dos espaços *</label>
                        <textarea id="limpezaReorganizacao-{{i}}" formControlName="limpezaReorganizacao" rows="3"
                          placeholder="Insira a limpeza e reorganização dos espaços" minlength="10" maxlength="500"></textarea>
                        <small class="campo-ajuda">Mínimo: 10 caracteres •
                          {{riscoCtrl.get('limpezaReorganizacao')?.value?.length || 0}}/500</small>
                        <small class="campo-ajuda">Informar o responsável pela ação.</small>
                        <div *ngIf="submitted && riscoCtrl.get('limpezaReorganizacao')?.errors" class="alert">
                          <div *ngIf="riscoCtrl.get('limpezaReorganizacao')?.errors?.['required']">* Campo é obrigatório
                          </div>
                          <div *ngIf="riscoCtrl.get('limpezaReorganizacao')?.errors?.['minlength']">* Mínimo de 10
                            caracteres</div>
                          <div *ngIf="riscoCtrl.get('limpezaReorganizacao')?.errors?.['maxlength']">* Máximo de 500
                            caracteres</div>
                        </div>
                      </div>

                      <div class="campo">
                        <label for="apoioPsicossocial-{{i}}">Apoio psicossocial à comunidade escolar *</label>
                        <textarea id="apoioPsicossocial-{{i}}" formControlName="apoioPsicossocial" rows="3"
                          placeholder="Insira o apoio psicossocial à comunidade escolar" minlength="10" maxlength="500"></textarea>
                        <small class="campo-ajuda">Mínimo: 10 caracteres •
                          {{riscoCtrl.get('apoioPsicossocial')?.value?.length || 0}}/500</small>
                        <small class="campo-ajuda">Informar o responsável pela ação.</small>
                        <div *ngIf="submitted && riscoCtrl.get('apoioPsicossocial')?.errors" class="alert">
                          <div *ngIf="riscoCtrl.get('apoioPsicossocial')?.errors?.['required']">* Campo é obrigatório
                          </div>
                          <div *ngIf="riscoCtrl.get('apoioPsicossocial')?.errors?.['minlength']">* Mínimo de 10
                            caracteres</div>
                          <div *ngIf="riscoCtrl.get('apoioPsicossocial')?.errors?.['maxlength']">* Máximo de 500
                            caracteres</div>
                        </div>
                      </div>

                      <div class="campo">
                        <label for="revisaoPlano-{{i}}">Revisão do Plano de Contingência com base no ocorrido *</label>
                        <textarea id="revisaoPlano-{{i}}" formControlName="revisaoPlano" rows="3"
                          placeholder="Insira a revisão do Plano de Contingência com base no ocorrido"
                          minlength="10" maxlength="500"></textarea>
                        <small class="campo-ajuda">Mínimo: 10 caracteres •
                          {{riscoCtrl.get('revisaoPlano')?.value?.length || 0}}/500</small>
                        <small class="campo-ajuda">Informar o responsável pela ação.</small>
                        <div *ngIf="submitted && riscoCtrl.get('revisaoPlano')?.errors" class="alert">
                          <div *ngIf="riscoCtrl.get('revisaoPlano')?.errors?.['required']">* Campo é obrigatório</div>
                          <div *ngIf="riscoCtrl.get('revisaoPlano')?.errors?.['minlength']">* Mínimo de 10 caracteres
                          </div>
                          <div *ngIf="riscoCtrl.get('revisaoPlano')?.errors?.['maxlength']">* Máximo de 500 caracteres
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="separador"></div>

                    <!-- SEÇÃO: ENCAMINHAMENTOS -->
                    <div class="secao-risco">
                      <h5 class="secao-titulo">Encaminhamentos</h5>

                      <div class="campo">
                        <label for="encaminhamentos-{{i}}">Registros das providências administrativas, técnicas ou
                          institucionais adotadas após a identificação do risco ou ocorrência do evento *</label>
                        <textarea id="encaminhamentos-{{i}}" formControlName="encaminhamentos" rows="3"
                          placeholder="Insira os registros das providências" minlength="10" maxlength="500"></textarea>
                        <small class="campo-ajuda">Mínimo: 10 caracteres •
                          {{riscoCtrl.get('encaminhamentos')?.value?.length || 0}}/500</small>
                        <small class="campo-ajuda">Articulação com órgãos da rede de proteção. Informar o responsável
                          pela ação.</small>
                        <div *ngIf="submitted && riscoCtrl.get('encaminhamentos')?.errors" class="alert">
                          <div *ngIf="riscoCtrl.get('encaminhamentos')?.errors?.['required']">* Campo é obrigatório
                          </div>
                          <div *ngIf="riscoCtrl.get('encaminhamentos')?.errors?.['minlength']">* Mínimo de 10
                            caracteres</div>
                          <div *ngIf="riscoCtrl.get('encaminhamentos')?.errors?.['maxlength']">* Máximo de 500
                            caracteres</div>
                        </div>
                      </div>
                    </div>

                    <div class="separador"></div>

                    <!-- SEÇÃO: SISTEMA DE ALERTA/COMUNICAÇÃO -->
                    <div class="secao-risco">
                      <h5 class="secao-titulo">Sistema de alerta / comunicação</h5>
                      <p class="secao-descricao">Formas e canais utilizados para avisar rapidamente a comunidade escolar
                        sobre situações de risco ou emergência</p>

                      <div class="campo">
                        <label for="comunicacaoInterna-{{i}}">Comunicação interna (equipe escolar, estudantes) *</label>
                        <textarea id="comunicacaoInterna-{{i}}" formControlName="comunicacaoInterna" rows="3"
                          placeholder="Insira a comunicação interna" minlength="10" maxlength="500"></textarea>
                        <small class="campo-ajuda">Mínimo: 10 caracteres •
                          {{riscoCtrl.get('comunicacaoInterna')?.value?.length || 0}}/500</small>
                        <small class="campo-ajuda">Informar o responsável pela ação.</small>
                        <div *ngIf="submitted && riscoCtrl.get('comunicacaoInterna')?.errors" class="alert">
                          <div *ngIf="riscoCtrl.get('comunicacaoInterna')?.errors?.['required']">* Campo é obrigatório
                          </div>
                          <div *ngIf="riscoCtrl.get('comunicacaoInterna')?.errors?.['minlength']">* Mínimo de 10
                            caracteres</div>
                          <div *ngIf="riscoCtrl.get('comunicacaoInterna')?.errors?.['maxlength']">* Máximo de 500
                            caracteres</div>
                        </div>
                      </div>

                      <div class="campo">
                        <label for="comunicacaoExterna-{{i}}">Comunicação externa (famílias, URE) *</label>
                        <textarea id="comunicacaoExterna-{{i}}" formControlName="comunicacaoExterna" rows="3"
                          placeholder="Insira a comunicação externa" minlength="10" maxlength="500"></textarea>
                        <small class="campo-ajuda">Mínimo: 10 caracteres •
                          {{riscoCtrl.get('comunicacaoExterna')?.value?.length || 0}}/500</small>
                        <small class="campo-ajuda">Informar o responsável pela ação.</small>
                        <div *ngIf="submitted && riscoCtrl.get('comunicacaoExterna')?.errors" class="alert">
                          <div *ngIf="riscoCtrl.get('comunicacaoExterna')?.errors?.['required']">* Campo é obrigatório
                          </div>
                          <div *ngIf="riscoCtrl.get('comunicacaoExterna')?.errors?.['minlength']">* Mínimo de 10
                            caracteres</div>
                          <div *ngIf="riscoCtrl.get('comunicacaoExterna')?.errors?.['maxlength']">* Máximo de 500
                            caracteres</div>
                        </div>
                      </div>

                      <div class="campo">
                        <label for="meiosSonoros-{{i}}">Meios sonoros, visuais ou digitais (diferenciar dos tradicionais
                          já convencionados) *</label>
                        <textarea id="meiosSonoros-{{i}}" formControlName="meiosSonoros" rows="3"
                          placeholder="Insira os meios sonoros, visuais ou digitais" minlength="10" maxlength="500"></textarea>
                        <small class="campo-ajuda">Mínimo: 10 caracteres •
                          {{riscoCtrl.get('meiosSonoros')?.value?.length || 0}}/500</small>
                        <small class="campo-ajuda">Informar o responsável pela ação.</small>
                        <div *ngIf="submitted && riscoCtrl.get('meiosSonoros')?.errors" class="alert">
                          <div *ngIf="riscoCtrl.get('meiosSonoros')?.errors?.['required']">* Campo é obrigatório</div>
                          <div *ngIf="riscoCtrl.get('meiosSonoros')?.errors?.['minlength']">* Mínimo de 10 caracteres
                          </div>
                          <div *ngIf="riscoCtrl.get('meiosSonoros')?.errors?.['maxlength']">* Máximo de 500 caracteres
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="separador"></div>

                    <!-- SEÇÃO: ANEXOS -->
                    <div class="secao-risco">
                      <h5 class="secao-titulo">Rota de fuga</h5>
                      <p class="secao-descricao">Caminho seguro, sinalizado e previamente definido para a evacuação
                        rápida do prédio escolar em situações de emergência</p>

                      <p class="sem-evidencias" *ngIf="getArquivosRisco(i).length === 0">
                        Nenhum documento foi adicionado.
                      </p>

                      <!-- CAIXA DE UPLOAD -->
                      <div *ngIf="!ehReadOnly" class="evidencias-box">
                        <input type="file" [id]="'arquivos-' + i" (change)="OnFileChange($event, i)" multiple hidden
                          accept=".jpg,.jpeg,.png,.pdf,.mp3,.mp4" />
                        <label [for]="'arquivos-' + i" class="btn-anexar">
                          <i class="fa fa-paperclip"></i>
                          Anexar documentos
                        </label>
                      </div>

                      <!-- Lista de arquivos anexados -->
                      <div *ngIf="getArquivosRisco(i).length > 0" class="arquivos-lista">
                        <app-card-arquivo-anexado *ngFor="let arquivo of getArquivosRisco(i); let j = index"
                          [arquivo]="arquivo" [index]="j" [showRemoveButton]="!ehReadOnly"
                          (visualizar)="visualizarArquivo($event, i)" (download)="DownloadArquivo($event, i)"
                          (remover)="popupremoverarquivo($event, i)">
                        </app-card-arquivo-anexado>
                      </div>
                    </div>

                    <div class="campo-excluir" *ngIf="!ehReadOnly">
                      <button type="button" (click)="removerRisco(i)">
                        <i class="fa fa-trash" title="Excluir"></i>
                        <span>Remover Risco</span>
                      </button>
                    </div>

                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <button *ngIf="!ehReadOnly" type="button" (click)="adicionarRisco()">+ Adicionar risco</button>
        </div>

        <!-- CIÊNCIA DOS RESPONSÁVEIS -->
        <div class="conteudo-select" style="margin-top: 20px;">
          <label style="display:flex; align-items:center; gap:10px;">
            <input type="checkbox" formControlName="cienciaResponsaveis"
              style="width:18px; height:18px; cursor:pointer;" />
            <span style="font-size: 1.45rem; color:#444;">
              Declaro, na qualidade de Diretor(a) da Unidade Escolar, que todas as pessoas citadas como responsáveis
              neste plano foram devidamente informadas
              e estão cientes de suas atribuições, compromissos e responsabilidades no âmbito das ações previstas.
            </span>
          </label>

          <div *ngIf="submitted && form.cienciaResponsaveis.errors" class="alert">
            <div>*Todos os envolvidos devem estar cientes para continuar.</div>
          </div>
        </div>

        <!-- BOTÕES -->
        <div class="container-btns">
          <input type="button" class="btn_outline" value="Download do Plano" aria-label="Download do Plano" (click)="gerarPDFPlano()" />
          <input *ngIf="!ehModal && !ehReadOnly" type="button" class="btn_outline" id="btnLimpar" value="Limpar"
            aria-label="Limpar" (click)="OnLimpar()" />
          <input *ngIf="ehModal" type="button" class="btn_outline" value="Fechar" aria-label="Fechar"
            (click)="FecharModal()" />
          <input *ngIf="!ehReadOnly" type="submit" class="btn_primary" value="Salvar" aria-label="Salvar" />
        </div>
      </div>
    </div>
  </section>

  <section *ngIf="!ehModal && !showCadastroModal" class="conteudo-principal" aria-labelledby="detalhes-chamado-title">
    <div class="container form-registro container-grid">
      <app-tabulator-table
        [tableData]="lstPlanos"
        [columnNames]="colunasGrid"
        [mostrarExportarHtml]="false"
        [tipoRelatorio]="3"
        [orientacaoPortrait]="false"
        [mostrarFiltro]="false"
        [legendaHtml]="legendaGrid"></app-tabulator-table>
    </div>
  </section>

</form>

<div *ngIf="showCadastroModal" class="formulario-tela-cheia">
  <div class="container-conviva form-registro formulario-tela-cheia__conteudo">
    <app-plano-contingencia-cadastro [planoContingencia]="planoSelecionado" [ehModal]="true" [ehEdicao]="ehEdit"
      [ehReadOnly]="ehReadOnly" [tituloAcaoModal]="tituloAcaoModal" [statusPlano]="statusPlano"
      [somenteAnexosERiscos]="somenteAnexosERiscosModal"
      (fechar)="FecharCadastroModal()">
    </app-plano-contingencia-cadastro>
  </div>
</div>

<app-modal *ngIf="showModalVisualizar">
  <div class="container-conviva form-registro modal-envolvidos">

    <div class="linha">
      <div class="conteudo-select">
        <label>URE:</label>
        <input type="text" [value]="planoSelecionado?.nmDiretoria" readonly />
      </div>

      <div class="conteudo-select">
        <label>Escola:</label>
        <input type="text" [value]="planoSelecionado?.nmEscola" readonly />
      </div>
    </div>

    <div class="linha">
      <div class="conteudo-select">
        <label>Vigência:</label>
        <input type="text" [value]="planoSelecionado?.vigencia" readonly />
      </div>
    </div>

    <div class="conteudo-textarea">
      <label for="nmEscola">Nome da Escola:</label>
      <textarea id="nmEscola" rows="2" [value]="planoSelecionado?.nmEscola" readonly></textarea>
    </div>

    <div class="conteudo-select">
      <label>Nome do Responsável:</label>
      <input type="text" [value]="planoSelecionado?.nomeResponsavel" readonly />
    </div>

    <h3 style="margin-top:20px;">Riscos</h3>
    <div class="accordion">
      <div *ngFor="let risco of riscosSelecionados; let i = index" class="accordion-item">
        <div class="accordion-header" (click)="abrirRisco(i)">
          <h4>Risco {{ i + 1 }}</h4>
        </div>

        <div class="accordion-body" [class.show]="riscoAberto === i">
          <div class="conteudo-select">
            <label>Perigo</label>
            <textarea rows="2" [value]="risco.perigo.join(', ')" readonly></textarea>
          </div>

          <div class="conteudo-select">
            <label>Vulnerabilidade</label>
            <textarea rows="2" [value]="risco.vulnerabilidade.join(', ')" readonly></textarea>
          </div>

          <div class="conteudo-select">
            <label>Justificativa de Vulnerabilidade</label>
            <textarea rows="2" [value]="risco.justificativaVulnerabilidade" readonly></textarea>
          </div>

          <div class="conteudo-select">
            <label>Dano</label>
            <textarea rows="2" [value]="risco.dano.join(', ')" readonly></textarea>
          </div>

          <div class="conteudo-select">
            <label>Justificativa de Dano</label>
            <textarea rows="2" [value]="risco.justificativaDano" readonly></textarea>
          </div>

          <div class="conteudo-select">
            <label>Grau de Risco</label>
            <textarea rows="2" [value]="risco.grauRisco" readonly></textarea>
          </div>

          <div class="conteudo-select">
            <label>Justificativa de Grau de Risco</label>
            <textarea rows="2" [value]="risco.justificativaGrauRisco" readonly></textarea>
          </div>

          <h6 style="margin-top: 1rem; font-weight: bold;">Ações antes do fato</h6>

          <div class="conteudo-select">
            <label>Prevenção</label>
            <textarea rows="2" [value]="risco.prevencao" readonly></textarea>
          </div>

          <div class="conteudo-select">
            <label>Mitigação</label>
            <textarea rows="2" [value]="risco.mitigacao" readonly></textarea>
          </div>

          <div class="conteudo-select">
            <label>Preparação</label>
            <textarea rows="2" [value]="risco.preparacao" readonly></textarea>
          </div>

          <h6 style="margin-top: 1rem; font-weight: bold;">Ações durante o fato</h6>

          <div class="conteudo-select">
            <label>Evacuação do Prédio</label>
            <textarea rows="2" [value]="risco.evacuacaoPredio" readonly></textarea>
          </div>

          <div class="conteudo-select">
            <label>Acionamento dos Órgãos</label>
            <textarea rows="2" [value]="risco.acionamentoOrgaos" readonly></textarea>
          </div>

          <div class="conteudo-select">
            <label>Isolamento das Áreas</label>
            <textarea rows="2" [value]="risco.isolamentoAreas" readonly></textarea>
          </div>

          <div class="conteudo-select">
            <label>Comunicação com URE</label>
            <textarea rows="2" [value]="risco.comunicacaoURE" readonly></textarea>
          </div>

          <h6 style="margin-top: 1rem; font-weight: bold;">Avaliação do Fato Ocorrido</h6>

          <div class="conteudo-select">
            <label>Avaliação dos Danos</label>
            <textarea rows="2" [value]="risco.avaliacaoDanos" readonly></textarea>
          </div>

          <div class="conteudo-select">
            <label>Limpeza e Reorganização</label>
            <textarea rows="2" [value]="risco.limpezaReorganizacao" readonly></textarea>
          </div>

          <div class="conteudo-select">
            <label>Apoio Psicossocial</label>
            <textarea rows="2" [value]="risco.apoioPsicossocial" readonly></textarea>
          </div>

          <div class="conteudo-select">
            <label>Revisão do Plano</label>
            <textarea rows="2" [value]="risco.revisaoPlano" readonly></textarea>
          </div>

          <h6 style="margin-top: 1rem; font-weight: bold;">Encaminhamentos</h6>

          <div class="conteudo-select">
            <label>Encaminhamentos</label>
            <textarea rows="2" [value]="risco.encaminhamentos" readonly></textarea>
          </div>

          <h6 style="margin-top: 1rem; font-weight: bold;">Sistema de Alerta/Comunicação</h6>

          <div class="conteudo-select">
            <label>Comunicação Interna</label>
            <textarea rows="2" [value]="risco.comunicacaoInterna" readonly></textarea>
          </div>

          <div class="conteudo-select">
            <label>Comunicação Externa</label>
            <textarea rows="2" [value]="risco.comunicacaoExterna" readonly></textarea>
          </div>

          <div class="conteudo-select">
            <label>Meios Sonoros/Visuais/Digitais</label>
            <textarea rows="2" [value]="risco.meiosSonoros" readonly></textarea>
          </div>

          <h6 style="margin-top: 1rem; font-weight: bold;">Anexos</h6>

          <div class="conteudo-select" *ngIf="risco.arquivos && risco.arquivos.length > 0">
            <div *ngFor="let arquivo of risco.arquivos" style="margin-bottom: 0.5rem;">
              <span>{{ arquivo.nome }}</span>
            </div>
          </div>
          <div class="conteudo-select" *ngIf="!risco.arquivos || risco.arquivos.length === 0">
            <span>Nenhum arquivo anexado</span>
          </div>
        </div>
      </div>
    </div>

    <div class="conteudo-select" style="margin-top: 20px;">
      <label style="display:flex; align-items:center; gap:10px;">
        <input type="checkbox" [checked]="true" disabled style="width:18px; height:18px;" />
        <span style="font-size: 1.35rem; color:#444;">
          Declaro, na qualidade de Diretor(a) da Unidade Escolar, que todas as pessoas citadas como responsáveis neste
          plano foram devidamente informadas
          e estão cientes de suas atribuições, compromissos e responsabilidades no âmbito das ações previstas.
        </span>
      </label>
    </div>

    <hr />
    <div class="container-btns">
      <input type="button" class="btn_primary" value="Voltar" (click)="fecharModalVisualizar()" />
    </div>
  </div>
</app-modal>

<app-modal class="modal-medium" *ngIf="showModalEliminar">
  <div class="container-conviva form-registro modal-envolvidos">
    <div class="card-modal">
      <div class="card-header-icon card-header--vermelho margin-bottom-20">
        <i class="fa-solid fa-times-circle" title="Enviar para a Validação"></i>
      </div>
      <div class="card-body">
        <h3 class="card-title card-title--vermelho margin-bottom-20">{{ descricaoModal }}</h3>
        <p class="card-paragraph">Detalhes:</p>
        <div class="box-info-modal">
          <span class="label">Ano</span>
          <span class="valor">{{ anoModal }}</span>
        </div>
        <div class="box-info-modal">
          <span class="label">Escola</span>
          <span class="valor">{{ escolaModal }}</span>
        </div>
        <span class="container-btns margin-top-20"></span>
        <div class="container-btns">
          <input type="button" (click)="fecharModalEliminar()" class="btn_outline btn_outline--danger"
            value="Cancelar" />
          <input type="button" (click)="confirmarAcaoEliminar()" class="btn_primary btn_primary--danger"
            value="Confirmar" />
        </div>
      </div>
    </div>
  </div>
</app-modal>

<!-- Modal Remover Risco -->
<app-modal class="modal-medium" *ngIf="showModalRemoverRisco">
  <div class="container-conviva form-registro modal-envolvidos">
    <div class="card-modal">
      <div class="card-header-icon card-header--vermelho">
        <i class="fa-solid fa-times-circle"></i>
      </div>
      <span class="card-title--vermelho">Tem certeza que deseja remover o risco?</span>
      <div class="callout callout-danger margin-top-20 margin-bottom-20">
        <i class="fa-solid fa-triangle-exclamation"></i>
        <span><strong>Atenção:</strong> Essa ação não poderá ser desfeita.</span>
      </div>
      <div class="detalhes-section">
        <span class="detalhes-title">Detalhes</span>
      </div>
      <div class="box-info-modal">
        <span class="label">Risco</span>
        <span class="valor">{{ nomeRiscoModal }}</span>
      </div>
      <span class="container-btns margin-top-20"></span>
      <div class="container-btns">
        <input type="button" (click)="fecharModalRemoverRisco()" class="btn_outline btn_outline--danger"
          value="Cancelar" />
        <input type="button" (click)="confirmarRemoverRisco()" class="btn_primary btn_primary--danger"
          value="Confirmar" />
      </div>
    </div>
  </div>
</app-modal>

<!-- Modal Enviar para Validação -->
<app-modal class="modal-medium" *ngIf="showModalEnviarValidacao">
  <div class="container-conviva form-registro modal-envolvidos">
    <div class="card-modal">
      <div class="card-header-icon card-header--azul margin-bottom-20">
        <i class="fa-solid fa-arrows-rotate" title="Enviar para a Validação"></i>
      </div>
      <div class="card-body">
        <h3 class="card-title card-title--azul margin-bottom-20">{{ descricaoModal }}</h3>
        <div class="callout-danger">
          <i class="fa-solid fa-circle-exclamation"></i>
          <p>
            <strong>Atenção:</strong>
            Depois da aprovação, a única modificação permitida será a inclusão de ações e o envio de documentos.
          </p>
        </div>
        <p class="card-paragraph margin-top-20">Detalhes:</p>
        <div class="box-info-modal">
          <span class="label">Ano</span>
          <span class="valor">{{ anoModal }}</span>
        </div>
        <div class="box-info-modal">
          <span class="label">Escola</span>
          <span class="valor">{{ escolaModal }}</span>
        </div>
        <span class="margin-bottom-20"></span>
        <div class="container-btns margin-top-20">
          <input type="button" (click)="fecharModalEnviarValidacao()" class="btn_outline" value="Cancelar" />
          <input type="button" (click)="confirmarEnviarValidacao()" class="btn_primary" value="Confirmar" />
        </div>

      </div>
    </div>

  </div>
</app-modal>

<!-- Modal Histórico de atualizações (layout timeline: igual à consulta) -->
<app-modal *ngIf="showModalHistorico" class="modal-historico-atualizacoes">
  <div class="modal-historico-atualizacoes__conteudo">
    <h2 class="modal-historico-atualizacoes__titulo">Histórico de atualizações</h2>
    <div class="modal-historico-atualizacoes__lista" *ngIf="(planoContingencia?.logs ?? []).length > 0">
      <div *ngFor="let log of (planoContingencia?.logs ?? []); let i = index" class="modal-historico-atualizacoes__item">
        <span class="modal-historico-atualizacoes__ponto" aria-hidden="true"></span>
        <div class="modal-historico-atualizacoes__bloco">
          <div class="modal-historico-atualizacoes__linha-data">
            <span class="modal-historico-atualizacoes__data">{{ (log.dataOperacao | date:'dd/MM/yyyy, HH:mm') || '—' }}</span>
            <span class="modal-historico-atualizacoes__tipo" *ngIf="getTextoOperacaoLog(log)">{{ getTextoOperacaoLog(log) }}</span>
          </div>
          <p class="modal-historico-atualizacoes__responsavel" [class.modal-historico-atualizacoes__responsavel--id]="ehIdResponsavel(log.nomeResponsavelLog)">
            <i class="fa fa-user" aria-hidden="true"></i>
            {{ log.nomeResponsavelLog || '—' }}
          </p>
        </div>
      </div>
    </div>
    <p *ngIf="planoContingencia && (!planoContingencia.logs || planoContingencia.logs.length === 0)" class="modal-historico-atualizacoes__vazio">Nenhuma atualização registrada.</p>
    <div class="modal-historico-atualizacoes__footer">
      <button type="button" class="modal-historico-atualizacoes__btn-fechar" (click)="fecharModalHistorico()">Fechar</button>
    </div>
  </div>
</app-modal>

<!-- Modal Visualizar Arquivo -->
<app-visualizar-arquivo *ngIf="showModalVisualizarArquivo && arquivoVisualizando" [arquivo]="arquivoVisualizando"
  (fechar)="fecharModalVisualizarArquivo()">
</app-visualizar-arquivo>

<!-- Modal Deletar Arquivo -->
<app-modal *ngIf="showModalDeletarArquivo" (fecharModal)="FecharModalDeletarArquivo()" class="modal-delete">
  <div class="container-modal-deletar">
    <h3>Excluir Arquivo</h3>
    <p>Deseja excluir o arquivo <b>{{ arquivoRemover?.nome }}</b>?</p>
    <div class="btns-deletar">
      <button type="button" class="btn_outline" (click)="FecharModalDeletarArquivo()">Cancelar</button>
      <button type="button" class="btn_primary" (click)="removeFile()">Confirmar</button>
    </div>
  </div>
</app-modal>

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Carregando ...</p>
</ngx-spinner>
